module.exports = __webpack_public_path__ + "roboto-v15-latin-regular.9f916e330c478bbfa2a0.eot";


//////////////////
// WEBPACK FOOTER
// ./~/primeng/resources/themes/omega/fonts/roboto-v15-latin-regular.eot
// module id = 619
// module chunks = 2